var _style, _path, _line, _path2, _path3, _path4, _polyline, _polyline2, _polyline3, _polyline4, _circle, _line2, _line3, _path5, _path6, _line4, _line5, _line6, _polyline5, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplecut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st328{fill:#FFFFFF;stroke:#000000;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st327{fill:none;stroke:#000000;stroke-width:0.87;stroke-miterlimit:10;}\n\t.st326{fill:#FFFFFF;stroke:#000000;stroke-width:1.73;stroke-miterlimit:10;}\n\t.st325{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st324{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st323{fill:none;stroke:#000000;stroke-width:0.43;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st322{fill:#FFFFFF;stroke:#000000;stroke-width:0.87;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st328",
    d: "M289.3,253.4l-4,45.8l-2.2,72.6l-6,50.8h-19.8c-0.9,0-1.8-0.1-2.7-0.3l-7.3-1.5l-12.8-5.3 c-1.2-0.5-2.4-1.2-3.4-2.1l-9.1-9.6l-14.9,4.8l-26.2,2.6c-1.6,0.2-3.1-0.1-4.6-0.6l-7.4-2.9l-19.8-7.5l0,0l-1.1-0.4l2.7-17.8 l0.5-3.7l27-180.8l16.2-47.3l2.4-7.2l-1.6-5.1l-2.4-8.2l3.4-2l0.6-0.4l1-0.4l27.3-12l19.4-8.6l3.5-1.6l2,1.7l11.7,3.3l1,0.5 c0,0,3.7,12.6,9.1,19.4l3.2,7.4l12.7,75.8C288.5,226.8,288.8,240.5,289.3,253.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st327",
    x1: 195.2,
    y1: 137.9,
    x2: 200.4,
    y2: 134.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M194.2,124.5l28.2-21.2c2-1.5,4.3-2.6,6.7-3.3l8-2.3c2.9-0.9,5.9-1,8.8-0.3l15.4,1.5l1.6,11.6l-13.6-2.2 c-1.7-0.5-3.6-0.5-5.3,0l-6.5,1.4c-2,0.6-3.9,1.6-5.6,2.8l-9.6,6.7l-13.5,14l-8,8.8L194.2,124.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st325",
    d: "M196.6,125l26.9-20.2c1.8-1.4,3.9-2.4,6.1-3l8-2.3c1.4-0.4,2.9-0.6,4.4-0.6c1.2,0,2.4,0.2,3.5,0.4l14.3,1.1 l1,7.2l-10.9-1h-0.2c-1-0.3-2.1-0.4-3.2-0.4c-1,0-2,0.2-2.9,0.4l-6.6,1.4H237c-2.2,0.7-4.3,1.7-6.1,3l-9.7,6.7l-13.8,13.9l-5.8,6.8 L196.6,125z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st328",
    d: "M269.4,205.9L252.7,338c-0.3,2.9-1.8,5.6-4.2,7.4l-77,60.4l-20.2-27.5l52.2-60.7c1.8-2.1,2.9-4.7,2.9-7.5 l1.6-45.9c0.1-2-0.1-4.1-0.4-6.1l-7.8-45.9c-0.4-2.4-0.6-4.8-0.6-7.3v-14.1c0-5.2,1.6-10.3,4.4-14.7l5.5-8.2 c4.9-7.4,13.1-12.1,22-12.6l1.5-0.1c5.9-0.3,11.8,1.7,16.3,5.6l11.9,10.5c3.5,3.2,5.8,7.5,6.3,12.3L269.4,205.9z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st324",
    points: "164.5,400.9 190.8,380.4 196.8,380.4 196.8,386 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st323",
    points: "197.6,129 195.2,130.8 198.6,142.5 196.1,150.4 187.4,178.2 180.8,198.1 150.1,400.3 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st323",
    points: "170.2,406.8 168.2,406.1 149.3,399 149.3,399 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st328",
    points: "151.3,378.3 134.1,398.3 152.3,420.8 171.4,405.9 151.3,378.3 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.6,
    cy: 410,
    r: 2.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st324",
    x1: 154.4,
    y1: 419.2,
    x2: 135.8,
    y2: 396.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st324",
    x1: 149.5,
    y1: 380.4,
    x2: 169.5,
    y2: 407.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st322",
    d: "M274.3,137.6l-4,3c-5.3,3.9-4.9,4.6-6.5,10.9l-4.8,18.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st324",
    d: "M273.7,136.7l-4.3,2.9c-5.3,3.9-4.9,4.6-6.5,10.9l-4.8,18.4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st327",
    x1: 218.4,
    y1: 122.4,
    x2: 216,
    y2: 160.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st324",
    x1: 219.5,
    y1: 122.4,
    x2: 217,
    y2: 160.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st327",
    x1: 225.4,
    y1: 363.5,
    x2: 222.1,
    y2: 403.4
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st324",
    points: "172.1,406.8 178.8,409.1 205,406.8 222.3,400.9 232.3,411.2 242,416.5 250.5,419.2 257.8,420  277.4,420 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st328",
    d: "M294.8,299.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st324",
    d: "M223.6,424.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplecut);
export default __webpack_public_path__ + "static/media/APPLE CUT.43793142dea333f6dfd15c9ddca0fe45.svg";
export { ForwardRef as ReactComponent };